import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const assignHolderToCategory = (category, holder) => request.put(`${API_BASE_URL}/blockchain/category/${category}/registered-users/${holder}/add`)

export default assignHolderToCategory